import { baseSchedulerApi as api } from '../baseSchedulerApi';

const injectedRtkApi = api.injectEndpoints({
  endpoints: build => ({
    healthCheckHealthcheckGet: build.query<
      HealthCheckHealthcheckGetApiResponse,
      HealthCheckHealthcheckGetApiArg
    >({
      query: () => ({ url: `/healthcheck` }),
    }),
    createShopInAccountAccountAccountIdShopsPost: build.mutation<
      CreateShopInAccountAccountAccountIdShopsPostApiResponse,
      CreateShopInAccountAccountAccountIdShopsPostApiArg
    >({
      query: queryArg => ({
        url: `/account/${queryArg.accountId}/shops`,
        method: 'POST',
        body: queryArg.createShopRequestPayload,
      }),
    }),
    listShopsInAccountAccountAccountIdShopsGet: build.query<
      ListShopsInAccountAccountAccountIdShopsGetApiResponse,
      ListShopsInAccountAccountAccountIdShopsGetApiArg
    >({
      query: queryArg => ({ url: `/account/${queryArg.accountId}/shops` }),
    }),
    updateShopShopsShopIdPut: build.mutation<
      UpdateShopShopsShopIdPutApiResponse,
      UpdateShopShopsShopIdPutApiArg
    >({
      query: queryArg => ({
        url: `/shops/${queryArg.shopId}`,
        method: 'PUT',
        body: queryArg.updateShopRequestPayload,
      }),
    }),
    deleteShopShopsShopIdDelete: build.mutation<
      DeleteShopShopsShopIdDeleteApiResponse,
      DeleteShopShopsShopIdDeleteApiArg
    >({
      query: queryArg => ({
        url: `/shops/${queryArg.shopId}`,
        method: 'DELETE',
      }),
    }),
    listShopsInRooftopRooftopRooftopIdShopsGet: build.query<
      ListShopsInRooftopRooftopRooftopIdShopsGetApiResponse,
      ListShopsInRooftopRooftopRooftopIdShopsGetApiArg
    >({
      query: queryArg => ({ url: `/rooftop/${queryArg.rooftopId}/shops` }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as schedulerApi };
export type HealthCheckHealthcheckGetApiResponse =
  /** status 200 Successful Response */ {
    [key: string]: string;
  };
export type HealthCheckHealthcheckGetApiArg = void;
export type CreateShopInAccountAccountAccountIdShopsPostApiResponse =
  /** status 200 Successful Response */ CreateShopResponsePayload;
export type CreateShopInAccountAccountAccountIdShopsPostApiArg = {
  accountId: string;
  createShopRequestPayload: CreateShopRequestPayload;
};
export type ListShopsInAccountAccountAccountIdShopsGetApiResponse =
  /** status 200 Successful Response */ ListShopsInAccountResponsePayload;
export type ListShopsInAccountAccountAccountIdShopsGetApiArg = {
  accountId: string;
};
export type UpdateShopShopsShopIdPutApiResponse =
  /** status 200 Successful Response */ UpdateShopResponsePayload;
export type UpdateShopShopsShopIdPutApiArg = {
  shopId: string;
  updateShopRequestPayload: UpdateShopRequestPayload;
};
export type DeleteShopShopsShopIdDeleteApiResponse =
  /** status 200 Successful Response */ any;
export type DeleteShopShopsShopIdDeleteApiArg = {
  shopId: string;
};
export type ListShopsInRooftopRooftopRooftopIdShopsGetApiResponse =
  /** status 200 Successful Response */ ListShopsInRooftopResponsePayload;
export type ListShopsInRooftopRooftopRooftopIdShopsGetApiArg = {
  rooftopId: string;
};
export type ShopStatus = 'ACTIVE' | 'DISABLED';
export type ShopHour = {
  iso_day_of_week: number;
  open_time: string;
  close_time: string;
};
export type CreateShopResponsePayload = {
  name: string;
  status: ShopStatus;
  street_address: string;
  city: string;
  state: string;
  zip_code: string;
  service_lead_xml_address: string;
  interval_duration_minutes: number;
  daily_appointment_limit: number;
  hours: ShopHour[];
  id: string;
  account_id: string;
};
export type ValidationError = {
  loc: (string | number)[];
  msg: string;
  type: string;
};
export type HttpValidationError = {
  detail?: ValidationError[];
};
export type CreateShopRequestPayload = {
  name: string;
  status: ShopStatus;
  street_address: string;
  city: string;
  state: string;
  zip_code: string;
  service_lead_xml_address: string;
  interval_duration_minutes: number;
  daily_appointment_limit: number;
  hours: ShopHour[];
  rooftop_id: string;
};
export type ShopPayload = {
  name: string;
  status: ShopStatus;
  street_address: string;
  city: string;
  state: string;
  zip_code: string;
  service_lead_xml_address: string;
  interval_duration_minutes: number;
  daily_appointment_limit: number;
  hours: ShopHour[];
  id: string;
  account_id: string;
};
export type ListShopsInAccountResponsePayload = {
  shops_by_rooftop: {
    [key: string]: ShopPayload[];
  };
};
export type UpdateShopResponsePayload = {
  name: string;
  status: ShopStatus;
  street_address: string;
  city: string;
  state: string;
  zip_code: string;
  service_lead_xml_address: string;
  interval_duration_minutes: number;
  daily_appointment_limit: number;
  hours: ShopHour[];
  id: string;
  account_id: string;
};
export type UpdateShopRequestPayload = {
  name: string;
  status: ShopStatus;
  street_address: string;
  city: string;
  state: string;
  zip_code: string;
  service_lead_xml_address: string;
  interval_duration_minutes: number;
  daily_appointment_limit: number;
  hours: ShopHour[];
};
export type ListShopsInRooftopResponsePayload = {
  shops: ShopPayload[];
};
export const {
  useHealthCheckHealthcheckGetQuery,
  useCreateShopInAccountAccountAccountIdShopsPostMutation,
  useListShopsInAccountAccountAccountIdShopsGetQuery,
  useUpdateShopShopsShopIdPutMutation,
  useDeleteShopShopsShopIdDeleteMutation,
  useListShopsInRooftopRooftopRooftopIdShopsGetQuery,
} = injectedRtkApi;
